import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../../api";

export default function UpdateUser() {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const [user, setUser] = useState({
    id: "",
    username: "",
    phone: "",
    balance: 0,
    role: "user",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Load user info from state or fetch from API
  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (state?.user) {
          setUser(state.user);
        } else {
          const res = await api.get(`/users/${id}`);
          setUser(res.data.user);
        }
      } catch (err) {
        console.error(err);
        alert("User not found");
        navigate("/admin-page");
      }
    };
    fetchUser();
  }, [id, state, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({
      ...prev,
      [name]: name === "balance" ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      await api.put(`/users/${user.id}`, {
        username: user.username,
        role: user.role,
        balance: user.balance,
      });
      setMessage("✅ User updated successfully!");
      setTimeout(() => navigate("/admin-page"), 1500);
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#082f52] flex justify-center items-center px-4 py-6">
      <motion.div
        className="w-full max-w-md bg-[#12385d] rounded-xl shadow-lg p-6 sm:p-8"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <h2 className="text-2xl sm:text-3xl font-semibold mb-4 text-center text-white font-serif">
          Update User
        </h2>

        {message && (
          <div className="bg-red-600 text-white p-3 mb-4 rounded text-center text-sm sm:text-base">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Username */}
          <div>
            <label className="text-gray-200 text-sm sm:text-base font-serif">
              Username
            </label>
            <input
              type="text"
              name="username"
              value={user.username}
              onChange={handleChange}
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
              required
            />
          </div>

          {/* Phone */}
          <div>
            <label className="text-gray-200 text-sm sm:text-base font-serif">
              Phone (read-only)
            </label>
            <input
              type="text"
              name="phone"
              value={user.phone}
              readOnly
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-gray-300 cursor-not-allowed rounded-md px-3 py-2 sm:py-3 text-sm sm:text-base"
            />
          </div>

          {/* Balance */}
          <div>
            <label className="text-gray-200 text-sm sm:text-base font-serif">
              Balance
            </label>
            <input
              type="number"
              name="balance"
              value={user.balance}
              readOnly
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white cursor-not-allowed rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            />
          </div>

          {/* Role */}
          <div>
            <label className="text-gray-200 text-sm sm:text-base font-serif">
              Role
            </label>
            <select
              name="role"
              value={user.role}
              onChange={handleChange}
              className="mt-1 w-full bg-[#0e2b48] border border-[#2c4e74] text-white rounded-md px-3 py-2 sm:py-3 focus:ring-2 focus:ring-blue-400 outline-none text-sm sm:text-base"
            >
              <option value="user">User</option>
              <option value="admin">Admin</option>
              <option value="super_admin">Super Admin</option>
            </select>
          </div>

          {/* Buttons */}
          <div className="flex justify-between mt-4">
            <button
              type="button"
              onClick={() => navigate("/admin-page")}
              className="bg-gray-700 hover:bg-gray-600 text-white px-5 py-2 sm:py-3 rounded-md text-sm sm:text-base transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`w-full sm:w-auto bg-gradient-to-r from-[#4e6d8c] to-[#6784a4] hover:opacity-90 text-white px-5 py-2 sm:py-3 rounded-md font-semibold text-sm sm:text-base transition ${
                loading ? "cursor-not-allowed opacity-50" : ""
              }`}
            >
              {loading ? "Updating..." : "Update User"}
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
